import { Group } from '@gripp/shared-logic';
import { colors, tokens } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { CopyRoutinesToWorkspace } from './copyRoutinesToWorkspace';
import { DownloadRoutineWithDateFilter } from './downloadRoutineWithDateFilter';
import { RoutinesGroupsPicker } from './routinesGroupsPicker';

type Props = {
  routineIds: string[];
  workspaceId: string;
  selectedGroups: Group[];
  onGroupsChange: (groups: Group[]) => void;
  onCreateGroup: (name: string) => Promise<Group>;
};

/**
 * Main body of the routines selection side panel. Renders RoutinesGroupsPicker
 * inline for group assignment, followed by Download and Copy-to-Workspace bulk
 * actions.
 */
export const RoutinesSelectionPanelMain = ({
  routineIds,
  workspaceId,
  selectedGroups,
  onGroupsChange,
  onCreateGroup,
}: Props) => {
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <Text style={[tokens.typography.label.largeEmphasised, styles.label]}>
        {t('asset.groups')}
      </Text>
      <RoutinesGroupsPicker
        selectedGroups={selectedGroups}
        onGroupsChange={onGroupsChange}
        onCreateGroup={onCreateGroup}
        workspaceId={workspaceId}
      />

      <DownloadRoutineWithDateFilter
        label={t('routines.menu.download')}
        routineIds={routineIds}
        workspaceId={workspaceId}
      />

      <CopyRoutinesToWorkspace
        routineIds={routineIds}
        workspaceId={workspaceId}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 12,
  },
  label: {
    color: colors.brand.black,
  },
});
